export function getDeletedIdsFromTwoArrays(currentItems = [], oldItems = []) {
  const deletedItems = oldItems
    .filter(old => !currentItems
      .some(current => current.id === old.id));
  return deletedItems.map(item => (item.id));
}